import React from 'react';
import LoadingScreen from 'src/frontend-common/components/LoadingScreen';
import { useGetActiveCompanyName } from 'src/hooks/useGetActiveCompanyName';
import { useParams } from 'react-router-dom';
import { isAdmin } from 'src/utils/user';
import { DetailProducts } from 'src/frontend-common/dto/Types/ProductType';
import ErrorBoundary from 'src/frontend-common/components/MicroServiceErrorBundary';
import { CustomerDetailProps } from 'src/frontend-common/dto/Interfaces/CustomerDetail/index';
import { useSelector } from 'react-redux';
import { selectUser } from 'src/redux/slices/userSlice';
import { NavigateCallbackFn } from 'src/frontend-common/dto/Interfaces/FrontendLookups';

const CustomerDetailPage: React.FC<{
  product: DetailProducts;
  navigateTo: NavigateCallbackFn;
  resolution_id?: string;
}> = ({ product, navigateTo, resolution_id }) => {
  const CustomerDetailPageRemote: React.FC<CustomerDetailProps> = React.lazy(() => import('FrontendCustomerDetail/FrontendCustomerDetail'));
  const activeCompany = useGetActiveCompanyName();
  const { id } = useParams<{ id: string }>();
  const user = useSelector(selectUser);

  return (
    <ErrorBoundary>
      <React.Suspense fallback={<LoadingScreen variant="circle" />}>
        <CustomerDetailPageRemote
          id={resolution_id ? resolution_id : id || ''}
          activeCompany={activeCompany}
          product={product}
          isUserAdmin={isAdmin(user)}
          navigateTo={navigateTo}
        />
      </React.Suspense>
    </ErrorBoundary>
  );
};

export default CustomerDetailPage;
